import { useRef } from 'react'
import { Transition } from 'react-transition-group'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
import styled from 'astroturf/react'
import { useSelector } from 'react-redux'

import { hideEventTypeDetailsSelector } from 'selectors/calendar'
import _Bar from "progress_bar-Bar.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/spotpicker/progress_bar.js?styleId=Bar";
import _Progress from "progress_bar-Progress.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/spotpicker/progress_bar.js?styleId=Progress";


const Bar = /*#__PURE__*/styled('div', null, {
  displayName: "Bar",
  styles: _Bar,
  attrs: ({
    value
  }) => ({
    style: {
      width: `${value}%`
    }
  })
})

const Progress = /*#__PURE__*/styled('div', null, {
  displayName: "Progress",
  styles: _Progress,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletUp: useDeviceType('isTabletUp'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const ProgressBar = ({ calendarActive, loadingProgress }) => {
  const hasNoSidebar = useSelector(hideEventTypeDetailsSelector)
  const nodeRef = useRef(null)

  return (
    <Transition
      in={calendarActive && loadingProgress < 100}
      timeout={{ enter: 300, exit: 600 }}
      nodeRef={nodeRef}
      unmountOnExit
    >
      {(state) => (
        <Progress ref={nodeRef} hasNoSidebar={hasNoSidebar} state={state} data-component="spotpicker-progress">
          <Bar value={loadingProgress} />
        </Progress>
      )}
    </Transition>
  )
}

export default ProgressBar
